export class ReportRepositoryService {
	constructor($resource, ApiService, Upload) {
		'ngInject';

		this.$resource = $resource;
        this.apiService = ApiService;
        this._upload = Upload;

        this.uploadPdfResourceUrl = this.apiService.getResourceUrl('upload-pdf');
    }

    uploadPdf(pdf) {
        const promise = this._upload.upload({
			url: this.uploadPdfResourceUrl,
			data: {
				fileObj: pdf,
			}
		});

		return promise.then(details => ({
				uuid: details.data.data.uuid
		}))
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/report-repository/report-repository.service.js